import { ClipboardList, UserRoundPen } from "lucide-react";
import { faltandoNoCadastro, ROTULO_DO_CAMPO_CONFIGURAVEL } from "@bookdental/schemas";
import { trpc } from "@/lib/trpc";
import { useFeature } from "@/lib/use-feature";
import { useConfiguracaoDePacientes } from "@/lib/use-configuracao-de-pacientes";

const selo =
  "inline-flex items-center gap-1 rounded-full bg-amber-50 px-2 py-0.5 text-[10px] font-semibold text-amber-800 ring-1 ring-amber-200 hover:bg-amber-100 dark:bg-amber-500/10 dark:text-amber-300 dark:ring-amber-500/30";

/**
 * O que Configurações › Pacientes pede e este paciente ainda não tem: obrigatórios do cadastro
 * (encaixe e importação entram só com o nome) e a anamnese vencida. Clicar leva à aba certa.
 */
export function SelosDoCadastro({ patient, onAbrirAba }: { patient: Record<string, unknown> & { id: string }; onAbrirAba: (aba: string) => void }) {
  const config = useConfiguracaoDePacientes();
  const temAnamnese = useFeature("patient.anamnese");
  const faltando = faltandoNoCadastro(config, patient, {
    semCpf: typeof patient.document === "string" && !!patient.document && !/^\d{11}$/.test(patient.document),
  });
  const renova = temAnamnese && config.anamnese.renovarACadaMeses > 0;
  const situacao = trpc.anamnese.situacao.useQuery({ patientIds: [patient.id] }, { enabled: renova });
  const vencida = renova && situacao.data?.porPaciente[patient.id] === "vencida";

  return (
    <>
      {faltando.length > 0 && (
        <button
          type="button"
          onClick={() => onAbrirAba("dados")}
          title={`Falta: ${faltando.map((c) => ROTULO_DO_CAMPO_CONFIGURAVEL[c]).join(", ")}`}
          className={selo}
        >
          <UserRoundPen className="h-3 w-3" /> Cadastro incompleto
        </button>
      )}
      {vencida && (
        <button type="button" onClick={() => onAbrirAba("anamnese")} className={selo}>
          <ClipboardList className="h-3 w-3" /> Anamnese vencida
        </button>
      )}
    </>
  );
}
